<template>
  <div class="topbar">
    <b-nav class="justify-content-end align-items-center bg-primary">
      <b-nav-item v-if="isAuthenticated" :to="{ name: 'Dashboard', params: { lang: lang, console: console } }" class="mr-auto">
        <span>{{ user.nick }}</span>
      </b-nav-item>
      <b-nav-item :to="{ name: 'Shop', params: { lang: lang, console: console } }">
        <img src="../../assets/images/shop.png" alt="Tienda" class="img-icon">
      </b-nav-item>
      <b-nav-item  v-if="isAuthenticated" :to="{ name: 'ShopPurchasedProducts', params: { lang: lang, console: console, type: 'av' } }">
        <img src="../../assets/images/warehouse.png" alt="Almacen" class="img-icon">
      </b-nav-item>
      <b-nav-item-dropdown class="dropdown__nav" noCaret right>
        <template slot="button-content">
          <img v-if="lang === 'es'" src="../../assets/images/spanish.png" alt="Idioma español">
          <img v-if="lang === 'en'" src="../../assets/images/english.png" alt="Idioma inglés">
          <img v-if="lang === 'pt'" src="../../assets/images/portuguese.png" alt="Idioma portugues">
          <img v-if="lang === 'it'" src="../../assets/images/it.png" alt="Idioma italiano">
          <img v-if="lang === 'fr'" src="../../assets/images/fr.png" alt="Idioma frances">
          <img v-if="lang === 'de'" src="../../assets/images/de.png" alt="Idioma aleman">
        </template>
        <b-dropdown-item @click="changeLanguage('es')">
          <img src="../../assets/images/spanish.png" alt="Idioma español">
        </b-dropdown-item>
        <b-dropdown-item @click="changeLanguage('en')">
          <img src="../../assets/images/english.png" alt="Idioma inglés">
        </b-dropdown-item>
        <b-dropdown-item @click="changeLanguage('pt')">
          <img src="../../assets/images/portuguese.png" alt="Idioma portugues">
        </b-dropdown-item>
        <b-dropdown-item @click="changeLanguage('it')">
          <img src="../../assets/images/it.png" alt="Idioma italiano">
        </b-dropdown-item>
        <b-dropdown-item @click="changeLanguage('fr')">
          <img src="../../assets/images/fr.png" alt="Idioma frances">
        </b-dropdown-item>
        <b-dropdown-item @click="changeLanguage('de')">
          <img src="../../assets/images/de.png" alt="Idioma aleman">
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item-dropdown class="dropdown__nav" noCaret right>
        <template slot="button-content">
          <img v-if="console === 'psn'" src="../../assets/images/psn-icon.png" alt="Psn">
          <img v-else-if="console === 'xbox'" src="../../assets/images/xbox-icon.png" alt="Xbox">
          <img v-else src="../../assets/images/pc-icon.png" alt="Pc">
        </template>
        <b-dropdown-item @click="changeConsole('psn')">
          <img src="../../assets/images/psn-icon.png" alt="Psn">
        </b-dropdown-item>
        <b-dropdown-item @click="changeConsole('xbox')">
          <img src="../../assets/images/xbox-icon.png" alt="Xbox">
        </b-dropdown-item>
        <b-dropdown-item @click="changeConsole('pc')">
          <img src="../../assets/images/pc-icon.png" alt="Pc">
        </b-dropdown-item>
      </b-nav-item-dropdown>
      <b-nav-item v-if="isAuthenticated">
        <img src="../../assets/images/money.png" alt="Monedas" class="mr-2 img-coin">
        <span>{{ user.money }}</span>
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'lang',
      'console',
      'user',
      'isAuthenticated'
    ])
  },
  methods: {
    changeConsole(con) {
      const route = this.$route
      this.$store.dispatch('SET_CONSOLE', con)
      localStorage.setItem('console', con)
      if (route.params.console) {
        route.params.console = con
        this.$router.push({name: route.name, params: route.params})
      }
    }
  }
}
</script>
